import classNames from 'classnames';
import { FC } from 'react';
import { Modal } from 'src/store/models/Modal';

import Button from '../Button/Button';
import classes from './WarningModal.module.scss';

export interface WarningModalProps {
  modal?: Modal;
  className?: string;
}

const WarningModal: FC<WarningModalProps> = ({ modal, className }) => {
  return (
    <div className={classNames(classes.Container, className, modal?.className)}>
      <h4>{modal?.title}</h4>
      {modal?.body && <div dangerouslySetInnerHTML={{ __html: modal?.body }} />}
      <footer>
        {modal?.secondaryButtonText ? (
          <Button
            className={classes.Secondary}
            onClick={modal?.secondaryAction}
            variant="outlined"
          >
            {modal?.secondaryButtonText}
          </Button>
        ) : null}
        {modal?.primaryButtonText ? (
          <Button className={classes.Primary} onClick={modal?.primaryAction}>
            {modal?.primaryButtonText}
          </Button>
        ) : null}
      </footer>
    </div>
  );
};

export default WarningModal;
